import styled from 'styled-components';
import { StepNavigation } from '../structure/StepNavigation';
import { sizes, theme } from 'theme';

type PageHeaderBackButtonProps = {
    backButtonTitle: string;
    backButtonAria: string;
    backButtonHref: string;
    backButtonNavigateState?: any;
    buttonFunctionOverride?: Function;
};

export default function NavBackButton({
    backButtonTitle,
    backButtonAria,
    backButtonHref,
    backButtonNavigateState,
    buttonFunctionOverride,
}: PageHeaderBackButtonProps): JSX.Element {
    return (
        <ButtonBackground>
            <StepNavigation
                title={backButtonTitle}
                aria={backButtonAria}
                href={backButtonHref}
                navigateState={backButtonNavigateState}
                buttonFunctionOverride={buttonFunctionOverride}
            />
        </ButtonBackground>
    );
}

const ButtonBackground = styled.div`
    width: min-content;
    background: ${theme.appBackgroundColour};
    border-radius: ${sizes.borderRadiusLg};
    padding: 2px;
`;
